<div>
  <div class="content-container">
    <!--<mat-icon id="close-icon" (click)="closeDialog()">X</mat-icon>-->
    <span class="content-span full-width">{{data.message1}}</span>
  </div>
  <button mat-flat-button id="ok-button" [mat-dialog-close]="true">OK</button>
</div>
